import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
//#region STYLES
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  width: '90vw',
  maxWidth: '600px',
  maxHeight: '90vh',
  overflowY: 'auto',
};
//#endregion

const OrcaModal = (props) => {
  return (

    <Modal
        open={props.isOpen}
        onClose={props.onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...modalStyle, ...props.sx }}>
            {props.children}
        </Box>
      </Modal>
  );
};

export default OrcaModal;
